export const renderOptions = (labelMap: Record<string, string>) =>
  Object.keys(labelMap).map((value) => (
    <option key={value} value={value}>
      {labelMap[value]}
    </option>
  ));

export const convertToLabelMap = (
  enumValues: { key: string; value: string }[]
): Record<string, string> =>
  enumValues.reduce(
    (acc, { key, value }) => {
      acc[key] = value;
      return acc;
    },
    {} as Record<string, string>
  );

export const renderOptionsFromOptions = (options: { label: string; value: string }[]) =>
  options.map(({ label, value }) => (
    <option key={value} value={value}>
      {label}
    </option>
  ));
